import { render, staticRenderFns } from "./PurchaseTable.vue?vue&type=template&id=ece16408&scoped=true&lang=html&"
import script from "./PurchaseTable.vue?vue&type=script&lang=js&"
export * from "./PurchaseTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece16408",
  null
  
)

export default component.exports